export default __webpack_public_path__ + "043399a828dcde1d2a719148cd89b246.svg";